const toKebabCase = (string) => {
  return string.replace(/\B([A-Z])/g, "-$1").toLowerCase();
};
const toCamelCase = (string) => {
  return string.replace(/^./, (match) => match.toLowerCase()).replace(/-(\w)/g, (_, p1) => {
    var _a;
    return (_a = p1 == null ? void 0 : p1.toUpperCase()) != null ? _a : "";
  });
};
export { toCamelCase, toKebabCase };
